

export const extracategories: any[]= [
  //NEE
    { id:48,name: 'TEA'},
    { id:47,name: 'TEL' },
    { id:50,name: 'Discapacidad intelectual' },
    { id:54,name: 'Discapacidad visual' },
    { id:54,name: 'Discapacidad auditiva' },
    { id:55,name: 'Discapacidad Motora' },
    { id:57,name: 'Hiperactividad' },
    { id:49,name: 'Función intelectual limítrofe (FIL)'},
    { id:61,name: 'Dislexía' },
    { id:60,name: 'Dislalía' },
    { id:59,name: 'Discalculía' },
    { id:52,name: 'Sindrome de down' },
    { id:56,name: 'Talento superior' },
    { id:51,name: 'Sindrome de Tourette' },
    { id:46,name: 'TDA'},
    { id:45,name: 'TDA+H' },
    { id:58,name: 'Hipotonía' },
    //SIMA
    { id:186,name: 'Tips profesores' },
    { id:514,name: 'Planificaciones'},
    { id:22,name: 'NEE' },
    { id:170,name: 'Experimentos/manualidades' },
    { id:481,name: 'Offline' },
    { id:185,name: 'Sima Robot' },
    { id:187,name: 'Sima Code' },
    { id:188,name: 'Sima Logic' },
    { id:747,name: 'Otros' }   
  ];